module.exports = __webpack_public_path__ + "img/feature_buy_freespin_zh.91d05a4b.png";